import { ValidationType } from "./event.interface";

/**
 * The validation-agent catalog as the picker sees it — SIMS-8223.
 *
 * Mirrors the backend `CatalogEntry` (libs/shared/src/agents/agentCatalog.ts).
 * The endpoint only ever returns entries that are ACTIVE, implemented and
 * compatible with the event's validation type, so the client does no filtering
 * of its own — an unavailable agent is ABSENT from the list rather than shown
 * greyed, which is the platform rule Qori confirmed in the v1.6 addendum.
 */

export enum AgentConfigFieldType {
	BOOLEAN = "BOOLEAN",
	NUMBER = "NUMBER",
	ENUM = "ENUM",
	STRING = "STRING",
}

export interface AgentConfigField {
	key: string;
	label: string;
	type: AgentConfigFieldType;
	required?: boolean;
	min?: number;
	max?: number;
	options?: string[];
	helpText?: string;
}

export interface ValidationAgentEntry {
	agentKey: string;
	/** AC7 — a binding records this, and resolves against it forever after. */
	version: string;
	name: string;
	/** Shown beneath the name in the picker (AC1). */
	description: string;
	/** Rendered as chips, so a designer sees compatibility rather than only feeling it (AC4). */
	supportedValidationTypes: ValidationType[];
	configSchema?: AgentConfigField[];
}

/**
 * What the event stores.
 *
 * Declared in event.interface.ts and re-exported here so callers can reach it
 * from either place while there is only ONE definition — see that file for why
 * the import must not run the other way.
 */
export type { EventValidationAgentBinding as ValidationAgentBinding } from "./event.interface";
